import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../../layer/ILoaderProps';
import { LoadableSource } from '../../../layer/LoadableSource';
import { Config } from '../../../../Config';

const SeaweedFarms = (props: ILoaderProps) => (
  <>
    {/* --- CLUSTERED CENTROIDS (low zoom) --- */}
    <LoadableSource
      path="https://apigeostore.longline.co.uk/dataset/6a91340a5b92748161790c9a1a9d6b063cdd199d"
      cluster
      ignore={["id", "continent", "ADM0_EN", 'vol_m3', 'use']}
      {...props}
    >
      {/* Cluster circles */}
      <Layer
        id="seaweed_farms_clusters"
        maxzoom={14}
        type="circle"
        filter={['has', 'point_count']}
        layout={{
          visibility: props.active ? 'visible' : 'none',
        }}
        paint={{
          'circle-color': 'white',
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            15, 10,
            20, 25,
            30,
          ],
          'circle-opacity': 0.7,
        }}
      />

      {/* Cluster count label */}
      <Layer
        id="seaweed_farms_cluster_count"
        maxzoom={14}
        type="symbol"
        filter={['has', 'point_count']}
        layout={{
          'text-field': '{point_count_abbreviated}',
          'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
          'text-size': 12,
          visibility: props.active ? 'visible' : 'none',
        }}
        paint={{
          'text-color': '#333',
        }}
      />
    </LoadableSource>

    {/* --- POLYGONS (high zoom) --- */}
    <LoadableSource
      path="https://apigeostore.longline.co.uk/dataset/6a91340a5b92748161790c9a1a9d6b063cdd199d"
      ignore={["id", "continent", "ADM0_EN", 'vol_m3', 'use']}
      {...props}
    >
      <Layer
        id="seaweed_farms_polygons"
        beforeId={Config.UI.before_layer}
        type="fill"
        layout={{
          visibility: props.active ? 'visible' : 'none',
        }}
        paint={{
          'fill-color': 'yellow',
          'fill-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8, 0,
            10, 0.5,
          ],
        }}
      />

      <Layer
        id="seaweed_farms_outline"
        beforeId={Config.UI.before_layer}
        type="line"
        layout={{
          visibility: props.active ? 'visible' : 'none',
        }}
        paint={{
          'line-color': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            'gold',
            'black',
          ],
          'line-width': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            3,
            1,
          ],
          'line-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            8, 0,
            10, 1,
          ],
        }}
      />
    </LoadableSource>
  </>
);

export { SeaweedFarms };
